<template>
  <BButton class="add-item" variant="secondary" @click.prevent="$emit('add')">
    <span> + </span>
  </BButton>
</template>

<script setup></script>
